import { useLocationState } from '../hooks';
import { StepsType } from '../model';
import { Scan } from '../components';
import { Employees } from './team';
import { Role } from './role';
import { Invite } from './invite';
import { Solutions } from './solutions';
import { Purpose } from './purpose';
import s from '../content/index.module.css';

export const Questionnaire = () => {
    const [{ query }] = useLocationState();
    const { step } = query;

    return (
        <div className={s.form}>
            <Scan step={step as StepsType} />

            {step === 'team' && <Employees />}
            {step === 'role' && <Role />}
            {step === 'invite' && <Invite />}
            {step === 'solutions' && <Solutions />}
            {step === 'purpose' && <Purpose />}
        </div>
    );
};
